<!--Do NOT change this file manually, it is being generated by 'fws icons' command.-->

<template>
    <component v-bind:is="component"/>
</template>

<script>
    import startcase from 'lodash.startcase';
    import AddressAcc from '../../../../assets/svg/ico-address-acc.svg';
    import ArrowDown from '../../../../assets/svg/ico-arrow-down.svg';
    import ArrowL from '../../../../assets/svg/ico-arrow-l.svg';
    import ArrowLeft from '../../../../assets/svg/ico-arrow-left.svg';
    import ArrowR from '../../../../assets/svg/ico-arrow-r.svg';
    import ArrowRightLong from '../../../../assets/svg/ico-arrow-right-long.svg';
    import ArrowRight from '../../../../assets/svg/ico-arrow-right.svg';
    import ArrowUp from '../../../../assets/svg/ico-arrow-up.svg';
    import BookingAcc from '../../../../assets/svg/ico-booking-acc.svg';
    import Bookmark from '../../../../assets/svg/ico-bookmark.svg';
    import Check from '../../../../assets/svg/ico-check.svg';
    import ChevronDown from '../../../../assets/svg/ico-chevron-down.svg';
    import Close from '../../../../assets/svg/ico-close.svg';
    import DashboardAcc from '../../../../assets/svg/ico-dashboard-acc.svg';
    import Deco from '../../../../assets/svg/ico-deco.svg';
    import Dog from '../../../../assets/svg/ico-dog.svg';
    import Edit from '../../../../assets/svg/ico-edit.svg';
    import Eye from '../../../../assets/svg/ico-eye.svg';
    import Facebook from '../../../../assets/svg/ico-facebook.svg';
    import Hand from '../../../../assets/svg/ico-hand.svg';
    import Happy from '../../../../assets/svg/ico-happy.svg';
    import ImgDec from '../../../../assets/svg/ico-img-dec.svg';
    import InfoCircle from '../../../../assets/svg/ico-info-circle.svg';
    import Instagram from '../../../../assets/svg/ico-instagram.svg';
    import Lock from '../../../../assets/svg/ico-lock.svg';
    import LogOut from '../../../../assets/svg/ico-log-out.svg';
    import Logo from '../../../../assets/svg/ico-logo.svg';
    import Minus from '../../../../assets/svg/ico-minus.svg';
    import PaymentAcc from '../../../../assets/svg/ico-payment-acc.svg';
    import PenSolid from '../../../../assets/svg/ico-pen-solid.svg';
    import PlusCircle from '../../../../assets/svg/ico-plus-circle.svg';
    import Plus from '../../../../assets/svg/ico-plus.svg';
    import Quote from '../../../../assets/svg/ico-quote.svg';
    import Reorder from '../../../../assets/svg/ico-reorder.svg';
    import SliderLeft from '../../../../assets/svg/ico-slider-left.svg';
    import SliderRight from '../../../../assets/svg/ico-slider-right.svg';
    import Trash from '../../../../assets/svg/ico-trash.svg';
    import Twitter from '../../../../assets/svg/ico-twitter.svg';
    import UserAcc from '../../../../assets/svg/ico-user-acc.svg';
    import UserCog from '../../../../assets/svg/ico-user-cog.svg';
    import User from '../../../../assets/svg/ico-user.svg';

    export default {
        props: {
            iconName: {
                type: String,
                required: true
            }
        },
        components: {
            AddressAcc,
            ArrowDown,
            ArrowL,
            ArrowLeft,
            ArrowR,
            ArrowRightLong,
            ArrowRight,
            ArrowUp,
            BookingAcc,
            Bookmark,
            Check,
            ChevronDown,
            Close,
            DashboardAcc,
            Deco,
            Dog,
            Edit,
            Eye,
            Facebook,
            Hand,
            Happy,
            ImgDec,
            InfoCircle,
            Instagram,
            Lock,
            LogOut,
            Logo,
            Minus,
            PaymentAcc,
            PenSolid,
            PlusCircle,
            Plus,
            Quote,
            Reorder,
            SliderLeft,
            SliderRight,
            Trash,
            Twitter,
            UserAcc,
            UserCog,
            User,

        },
        computed: {
            component() {
                return startcase(this.iconName.replace('ico-', '')).replace(' ', '');
            }
        }
    };
</script>
